import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  CustomerBatchesParams,
  CustomerBatchesResponse,
} from '@scale/shared/types/endpoints/customer/batches/customerBatches';

export async function getCustomerBatches(
  query: CustomerBatchesParams,
): Promise<CustomerBatchesResponse> {
  return apiFetch(null, 'internal/batches', { query });
}
